package com.shadowings.gero.data.lessons.chapter11

import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_frasi_con_soggetto_1
import gero.composeapp.generated.resources.exp_content_frasi_con_soggetto_2
import gero.composeapp.generated.resources.exp_content_frasi_con_soggetto_3
import gero.composeapp.generated.resources.exp_content_frasi_con_soggetto_4
import gero.composeapp.generated.resources.exp_content_frasi_con_soggetto_5
import gero.composeapp.generated.resources.exp_title_frasi_con_soggetto

fun getFrasiConSoggettoContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_frasi_con_soggetto,
            content = Res.string.exp_content_frasi_con_soggetto_1,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_con_soggetto,
            content = Res.string.exp_content_frasi_con_soggetto_2,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_con_soggetto,
            content = Res.string.exp_content_frasi_con_soggetto_3,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_con_soggetto,
            content = Res.string.exp_content_frasi_con_soggetto_4,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_con_soggetto,
            content = Res.string.exp_content_frasi_con_soggetto_5,
            face = Faces.Happy,
            character = Characters.Zeta,
        ),
    )
}
